module.exports = __webpack_public_path__ + "static/img/8.4043fb9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/sp/8.png
// module id = BF/R
// module chunks = 0